<template>
    <div class="bestelluebersichtHolder">
        <router-view></router-view>
        <div class="bestelluebersichtTop">
            <button v-if="bestellBestand.length > 0" class="bestelluebersichtSave" @click="save()">save</button>

                <select v-if="bestellBestand.length > 0" class="bestellSortSelect" v-model="bestellSort">
                    <option value="datum_auf">datum auf</option>
                    <option value="datum_ab">datum ab</option>
                    <option value="artnum_auf">artnum auf</option>
                    <option value="artnum_ab">artnum ab</option>
                </select>
        </div>
        <div>
            <div v-if="verbrauchsMat === '3' && done === '0'">
                Offene Bestellungen EM Material
            </div>
            <div v-if="verbrauchsMat === '2' && done === '0'">
                Offene Bestellungen SFS Material
            </div>
            <div v-if="verbrauchsMat === '1' && done === '0'">
                Offene Bestellungen SRM Material
            </div>
            <div v-if="verbrauchsMat === '0' && done === '0'">
                Offene Bestellungen Primär Material
            </div>
            <div v-if="verbrauchsMat === '4' && done === '0'">
                Offene Bestellungen Sekundär Material
            </div>
            <div v-if="verbrauchsMat === '5' && done === '0'">
                Offene Bestellungen Küchen Material
            </div>
            <div v-if="verbrauchsMat === '3' && done === '1'">
                Abgeschlossene Bestellungen EM Material
            </div>
            <div v-if="verbrauchsMat === '2' && done === '1'">
                Abgeschlossene Bestellungen SFS Material
            </div>
            <div v-if="verbrauchsMat === '1' && done === '1'">
                Abgeschlossene Bestellungen SRM Material
            </div>
            <div v-if="verbrauchsMat === '0' && done === '1'">
                Abgeschlossene Bestellungen Primär Material
            </div>
            <div v-if="verbrauchsMat === '4' && done === '1'">
                Abgeschlossene Bestellungen Sekundär Material
            </div>
            <div v-if="verbrauchsMat === '5' && done === '1'">
                Abgeschlossene Bestellungen Küchen Material
            </div>
        </div>
        <div class="bestelluebersichtItemHolder">
            <!-- <div v-for="item in bestellBestand" class="bestelluebersichtItem">
                <div class="bestelluebersichtItemTextHolder">
                    <div class="bestelluebersichtItemTextHolderText"@click="openArtInfo(item.id)">
                        <p>{{item.artnum}}</p>
                        <p>{{item.shorttxt}}</p>
                        <p>bestand: {{item.besMax}}</p>
                        <p>offene Bestellung:</p>
                        <p v-if="item.mengeneinheit == 'Packung' && item.bestell < 2">{{item.bestell}} {{item.mengeneinheit}} à {{item.StkProEinheit}} Stk</p>
                        <p v-if="item.mengeneinheit == 'Packung' && item.bestell > 1">{{item.bestell}} {{item.mengeneinheit}}en à {{item.StkProEinheit}} Stk</p>
                        <p v-if="item.mengeneinheit == 'Stk'">{{item.bestell}} Stk</p>
                    </div>
                    <input type="checkbox">
                    <input type="number">
                    <div class="bestelluebersichtItemTextHolderButtons">
                        <button class="bestelluebersichtButton" @click="add(item.id)">+</button>
                        <button class="bestelluebersichtButton" @click="sub(item.id)">-</button>
                    </div>
                </div>
            </div> -->

            <div class="bestellungItemHolder">
                <table class="bestellungTable">
                    <tr>
                        <th class="bestellungHeadCells">bestell datum</th>
                        <th class="bestellungHeadCells">SBB Art. Nummer</th>
                        <th class="bestellungHeadCells">SAP-Bezeichnung</th>
                        <th class="bestellungHeadCells">Lagerort</th>
                        <th class="bestellungHeadCells">Momentaner Bestand</th>
                        <th class="bestellungHeadCells">schon gekommen</th>
                        <th class="bestellungHeadCells">offene menge</th>
                        <th class="bestellungHeadCells">Me-Einheit</th>
                        <th class="bestellungHeadCells">eingetroffe Stk</th>
                        <th class="bestellungHeadCells">komplet</th>
                        <th class="bestellungHeadCells" v-if="userLev.indexOf(6) > -1">abschliessen</th>
                    </tr>
                    <tr v-for="item in bestellBestand"
                        :key="item.id"
                        class="bestellungItem"
                    >
                        <td class="bestellungCells" @click="openArtInfo(item.artId)">{{formatDate(item.datum)}}</td>
                        <td class="bestellungCells" @click="openArtInfo(item.artId)">{{item.artnum}}</td>
                        <td class="bestellungCells" @click="openArtInfo(item.artId)">{{item.shorttxt}}</td>
                        <td class="bestellungCells" @click="openArtInfo(item.artId)">{{item.lagerOrt}}</td>
                        <td class="bestellungCells" @click="openArtInfo(item.artId)">{{item.besMax}}</td>
                        <td class="bestellungCells" @click="openArtInfo(item.artId)">{{item.eingetroffen}}</td>
                        <td class="bestellungCells" @click="openArtInfo(item.artId)">{{item.anzahl-item.eingetroffen}}
                        </td>

                        <td class="bestellungCells" @click="openArtInfo(item.artId)">
                            {{item.mengeneinheit}}
                        </td>
                        <!-- <td class="bestellungCells" @click="openArtInfo(item.artId)" v-if="item.packung">
                            {{item.packAnzahl}} Packung à {{item.StkProEinheit}} {{item.mengeneinheit}}</td>
                         -->
                        <td class="bestellungCells">
                            <input type="number" class="bestellInput" :disabled="item.checked || isDone()"
                                   v-model="item.gekommen"/>
                        </td>

                        <td class="bestellungCellsCheck">
                            <label class="bestellCheckBox">
                                <input type="checkbox" v-model="item.checked" value="item.bestell"
                                       @click="updateEingetroffen(item.checked,item.anzahl,item.eingetroffen, item.bestellungenId)"
                                       :disabled="isDone()"/>
                                <span class="bestellCheckmark"></span>
                            </label>
                        </td>

                        <td class="bestellungCellsCheck" v-if="userLev.indexOf(6) > -1">
                            <label class="bestellCheckBox">
                                <input type="checkbox" v-model="item.done" value="item.done">
                                <span class="bestellCheckmark"></span>
                            </label>
                        </td>

                    </tr>
                </table>
                <div class="bestellungKeine" v-if="bestellBestand.length <1">
                    keine Bestellungen vorhanden
                </div>
            </div>

        </div>
    </div>
</template>

<script>
import moment from 'moment';

export default {
    components: {},
    data() {
        return {
            bestellSort: 'datum_auf'
        }
    },
    props: {
        stao: {
            type: String,
            default: '1'
        },
        verbrauchsMat: {
            type: String,
            default: '0'
        },
        done: {
            type: String,
            default: '0'
        }
    },
    computed: {
        bestellBestand() {
            return this.$store.getters['lager/bestellteArt'];
        },
        userLev() {
            return this.$store.getters['user/autLev'];
        }
    },
    watch: {
        verbrauchsMat: function() {
            this.$store.dispatch('lager/bestellteArt', {
                stao: this.stao,
                verbrauchsMat: this.verbrauchsMat,
                done: this.done
            });
        },
        done: function() {
            this.$store.dispatch('lager/bestellteArt', {
                stao: this.stao,
                verbrauchsMat: this.verbrauchsMat,
                done: this.done
            });
        },
        bestellSort: function() {
            this.$store.dispatch('lager/bestellteArt', {
                stao: this.stao,
                verbrauchsMat: this.verbrauchsMat,
                done: this.done,
                sort: this.bestellSort
            });
        }

    },
    methods: {
        openArtInfo(id) {
            if (this.userLev.indexOf(6) > -1) {
                this.$router.push('artdetails/' + id + '/');
            }
        },
        updateEingetroffen(checked, anzahl, eingetroffen, id) {
            for (let i = 0; i < this.bestellBestand.length; i++) {
                if (this.bestellBestand[i].bestellungenId === id) {
                    if (checked) {
                        this.bestellBestand[i].gekommen = 0;
                    } else {
                        this.bestellBestand[i].gekommen = anzahl - eingetroffen;
                    }
                }
            }
        },
        formatDate(date) {
            return moment(date).format('YYYY-MM-DD HH:mm');
        },
        // add(id){
        //     // go through the art and find the one with the correct id
        //     for(var i=0;i < this.bestellBestand.length;i++){
        //         if(this.bestellBestand[i].id == id && this.bestellBestand[i].bestell >=1){
        //             this.bestellBestand[i].besMax += 1;
        //             this.bestellBestand[i].bestell -= 1;
        //             break;
        //         }
        //     }
        // },
        // sub(id){
        //     // go through the art and find the one with the correct id
        //     for(var i=0;i < this.bestellBestand.length;i++){
        //         if(this.bestellBestand[i].id == id && this.bestellBestand[i].besMax >=1){
        //             this.bestellBestand[i].besMax -= 1;
        //             this.bestellBestand[i].bestell += 1;
        //             break;
        //         }
        //     }
        // },
        save() {
            this.$store.dispatch('lager/bestellUpdate');
        },
        isDone() {
            if (this.done === '0') {
                return false;
            } else {
                return true;
            }
        }

    },
    beforeDestroy() {
    },
    created() {
        //     this.$store.dispatch('lager/bestellteArt',{stao:this.stao});
    },
    mounted() {
        this.$store.dispatch('lager/bestellteArt', {
            stao: this.stao,
            verbrauchsMat: this.verbrauchsMat,
            done: this.done,
            sort: this.bestellSort
        });
    }
}
</script>

<style scoped lang="scss">

    .bestelluebersichtHolder {
        position: absolute;
        width: 100%;
        height: 100vh;
        /*overflow-y: scroll;*/
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        top: 0;
        left: 0;
    }

    .bestellungKeine {
        height: 100%;
        width: 100%;
        text-align: center;
        color: $color-red;
    }

    .bestelluebersichtTop {
        display: flex;
        justify-content: center;
        width: 100%;
        height: 80px;
        background-color: $color-white;
    }

    .bestelluebersichtSave {
        background-color: $color-green;
        color: $color-white;
        font-size: 2.5rem;
        width: 12.5rem;
    }

    .bestellSortSelect {
    height: 3rem;
    font-size: 2rem;
    }

    .bestelluebersichtItemHolder {
        display: flex;
        flex-direction: column;
        background-color: $color-white;
        width: 100%;
        height: 100%;
        overflow: scroll;
    }

    .bestelluebersichtItem {
        display: flex;
        flex-direction: column;
        padding: 0.375rem;
        cursor: pointer;
        border-bottom: 0.125rem solid black;
    }

    .bestelluebersichtItemTextHolder {
        display: flex;
        flex-direction: row;
        flex: 1;
    }

    .bestelluebersichtItemTextHolderText {
        display: flex;
        flex-direction: column;
        flex: 1;
    }

    .bestelluebersichtItemTextHolderText:hover {
        background-color: $color-gray;
    }

    .bestelluebersichtItemTextHolderText:active {
        background-color: $color-green;
    }

    .bestelluebersichtItemTextHolderButtons {
        display: flex;
        flex-direction: row;
    }

    .bestelluebersichtButton {
        width: 120px;
        font-size: 2.5rem;
    }

    /*=======================================================================================*/

    .bestellungItemHolder {
        display: flex;
        flex-direction: column;
        background-color: $color-white;
        width: 100%;
        height: 100%;
        overflow: scroll;
    }

    .bestellungTable {
        border-collapse: collapse;
        margin-left: 1.25rem;
    }

    .bestellungItem {
        font-size: 1.25rem;
        border: none;
        padding: 0.375rem;
        cursor: pointer;
        height: 2.5rem;
    }

    .bestellungItem:hover {
        background-color: $color-gray;
    }

    .bestellungItem:active {
        background-color: $color-green;
    }

    .bestellungHeadCells {
        padding: 0.625rem;
    }

    .bestellungCells {
        border: none;
        padding: 0.625rem;
        text-align: center;
    }

    .bestellungCellsCheck {
        /*display:flex;*/
        height: 2rem;
        justify-content: center;
        align-items: center;
        position: relative;

    }

    .bestellInput {
        font-size: 1.25rem;
        width: 100px;
    }

    /*============ custom checkbox =============*/
    .bestellCheckBox {
        display: block;
        position: absolute;
        padding-left: 35px;
        margin-bottom: 12px;
        cursor: pointer;
        user-select: none;
        font-size: 22px;
        top: 50%;
        left: 50%;
        transform: translate(-13px, -13px);
    }

    /* Hide the browser's default checkbox */
    .bestellCheckBox input {
        position: absolute;
        opacity: 0;
        cursor: pointer;
        height: 0;
        width: 0;
    }

    /* On mouse-over, add a grey background color */
    .bestellCheckBox:hover input ~ .bestellCheckmark {
        background-color: #ccc;
    }

    /* Create a custom checkbox */
    .bestellCheckmark {
        position: absolute;
        top: 0;
        left: 0;
        height: 1.5rem;
        width: 1.5rem;
        background-color: #eee;
    }

    /* When the checkbox is checked, add a blue background */
    .bestellCheckBox input:checked ~ .bestellCheckmark {
        background-color: #2196F3;
    }

    /* Create the checkmark/indicator (hidden when not checked) */
    .bestellCheckmark:after {
        content: "";
        position: absolute;
        display: none;
    }

    /* Show the checkmark when checked */
    .bestellCheckBox input:checked ~ .bestellCheckmark:after {
        display: block;
    }

    /* Style the checkmark/indicator */
    .bestellCheckBox .bestellCheckmark:after {
        left: 9px;
        top: 0.375rem;
        width: 0.375rem;
        height: 0.625rem;
        border: solid $color-white;
        border-width: 0 3px 3px 0;
        transform: rotate(45deg);
    }

    /*=============== / custom checkbox ================*/

    @include medium {

    }

    @include extra-large {

    }

</style>
